<template>
    <div class="animated fadeIn master-detail-page">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <div v-else>
            <div class="master-back-wrapper">
                <b-button type="button" name="tipeBarangBackBtn" @click="$router.go(-1)">
                    <i class="fa fa-angle-left mr-2"></i>Back
                </b-button>
            </div>
            <div class="master-form-card">
            <h5 class="master-page-title">Detail Tipe Barang</h5>
            <div class="detail-data-wrapper mb-4">
                <h6 class="form-title">DATA TIPE</h6>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Tipe Barang</b-col>
                    <b-col v-if="tipeBarang.name != null">{{tipeBarang.name}}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Merk Barang</b-col>
                    <b-col v-if="tipeBarang.merk.name != null">{{tipeBarang.merk.name}}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Jenis Barang</b-col>
                    <b-col v-if="tipeBarang.jenis.name != null">{{tipeBarang.jenis.name}}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2" v-if="!tipeBarang.hasTahun">
                    <b-col cols="4" class="detail-data-label">Harga</b-col>
                    <b-col>
                        <span v-if="tipeBarang.harga == null">{{$helper.addThousandSeparator(tipeBarang.harga)}} </span>
                        <span v-else>Rp. {{$helper.addThousandSeparator(tipeBarang.harga)}} </span>
                    </b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Status</b-col>
                    <b-col v-if="tipeBarang.isActive == true">AKTIF</b-col>
                    <b-col v-else>NON-AKTIF</b-col>
                </b-row>
            </div>
            <div class="detail-data-wrapper mb-4" v-if="tipeBarang.hasTahun">
                <h6 class="form-title">HARGA / TAHUN</h6>
                <b-table bordered hover show-empty :fields="fieldHarga" :busy="isBusy" :items="tipeBarang.tahun" responsive class="mb-3">
                    <template v-slot:table-busy>
                        <div class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>  Loading data...</strong>
                        </div>
                    </template>
                    <template v-slot:empty>
                        Tidak ada data harga tahun.
                    </template>
                    <template v-slot:cell(hargaElektronik)="row">
                        <div class="text-left no wrap" v-if="row.item.harga == null">{{$helper.addThousandSeparator(row.item.harga)}} </div>
                        <div class="text-left no wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.harga)}} </div>
                    </template>
                    <template v-slot:cell(hargaBpkb)="row">
                        <div class="text-left no wrap" v-if="row.item.hargaBpkb == null">{{$helper.addThousandSeparator(row.item.hargaBpkb)}} </div>
                        <div class="text-left no wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.hargaBpkb)}} </div>
                    </template>
                    <template v-slot:cell(hargaKendaraan)="row">
                        <div class="text-left no wrap" v-if="row.item.hargaKendaraan == null">{{$helper.addThousandSeparator(row.item.hargaKendaraan)}} </div>
                        <div class="text-left no wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.hargaKendaraan)}} </div>
                    </template>
                    <template v-slot:table-busy>
                        <div class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>  Loading data...</strong>
                        </div>
                    </template>
                </b-table>
            </div>
            <div class="detail-data-wrapper mb-4" >
                <h6 class="form-title">KONDISI</h6>
                <b-table bordered hover show-empty :fields="fields" :busy="isBusy" :items="tipeBarang.kondisi" responsive class="mb-3">
                    <template v-slot:table-busy>
                        <div class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>  Loading data...</strong>
                        </div>
                    </template>
                    <template v-slot:empty>
                        Tidak ada data spesifikasi.
                    </template>
                    <template v-slot:cell(klasifikasi)="row">
                        <div v-if="row.item.dus !== null">
                            <span v-if="row.item.dus">Dus</span>
                            <span v-else>Non Dus</span>
                        </div>
                        <div v-else>
                            <span v-if="row.item.namaSendiri">BPKB a/n Sendiri</span>
                            <span v-else>BPKB a/n Orang Lain</span>
                        </div>
                    </template>
                    <template v-slot:cell(hargaMaksimal)="row">
                        <div class="text-right no wrap" v-if="row.item.hargaMaksimal == null">{{$helper.addThousandSeparator(row.item.hargaMaksimal)}} </div>
                        <div class="text-right no wrap text-danger" v-else-if="row.item.hargaMaksimal < 0">Rp. {{$helper.addThousandSeparator(row.item.hargaMaksimal)}} </div>
                        <div class="text-right no wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.hargaMaksimal)}} </div>
                    </template>
                    <template v-slot:cell(nominalAngka)="row">
                        <div class="text-right no wrap" v-if="row.item.nominalAngka == null">{{$helper.addThousandSeparator(row.item.nominalAngka)}} </div>
                        <div class="text-right no wrap text-danger" v-else-if="row.item.nominalAngka < 0">Rp. {{$helper.addThousandSeparator(row.item.nominalAngka)}} </div>
                        <div class="text-right no wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.nominalAngka)}} </div>
                    </template>
                    <template v-slot:cell(nominalPersen)="row">
                        <div class="text-right no-wrap" v-if="row.item.nominalPersen == null">{{$helper.addThousandSeparator(row.item.nominalPersen)}} </div>
                        <div class="text-right no-wrap text-danger" v-else-if="row.item.nominalPersen < 100 ">{{$helper.addThousandSeparator(row.item.nominalPersen)}} %</div>
                        <div class="text-right no-wrap" v-else>{{$helper.addThousandSeparator(row.item.nominalPersen)}} %</div>
                    </template>
                    <template v-slot:table-busy>
                        <div class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>  Loading data...</strong>
                        </div>
                    </template>
                </b-table>
            </div>
            <div class="detail-edit-btn">
                <b-button variant="pgiBtn" name="tipeBarangEditBtn" @click="editTipeBarang">Edit</b-button>
            </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'detail-tipe-barang',
    data(){
        return{
            id: null,
            initStatus: 0,
            isBusy: true,
            tipeBarang: {
                merk: {
                    id: null,
                    name: null
                },
                jenis: {
                    id: null,
                    name: null
                }
            },
            merkBarang: "",
            jenisBarang: "",
            kondisiBarang: [],
            hargaTahun: [],
            fields: [
                { key: "name", label: "Grade Barang", sortable:true},
                { key: "klasifikasi", label: "Klasifikasi", sortable:true},
                { key: "hargaMaksimal", label: "Harga Maksimal", sortable: true},
                { key: "nominalAngka", label: "Nominal Angka", sortable: true},
                { key: "nominalPersen", label: "Nominal Persen", sortable: true},
                { key: "keterangan", label: "Keterangan", sortable: true},
            ],
        }
    }, 
    computed: {
        // Kolom harga mengikuti jenis barang: kendaraan (Harga Kendaraan + BPKB) atau satu kolom Harga
        fieldHarga() {
            const rows = this.tipeBarang.tahun || []
            const hasKendaraan = rows.some(x => x.hargaKendaraan != null || x.hargaBpkb != null)
            const fields = [{ key: "tahun", label: "Tahun", sortable: true }]
            if (hasKendaraan) {
                fields.push({ key: "hargaKendaraan", label: "Harga Kendaraan", sortable: true })
                fields.push({ key: "hargaBpkb", label: "Harga BPKB", sortable: true })
            }
            else {
                fields.push({ key: "hargaElektronik", label: "Harga", sortable: true })
            }
            return fields
        }
    },
    methods:{

        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0
            this.id = this.$route.params.id

            let getSingleTipeBarang = this.$axios.get(`barang-tipe/${this.id}`).then(response => {
                this.tipeBarang = response.data

                if (this.tipeBarang.kondisi.length == 0 && this.tipeBarang.merk.id != null) {
                    this.$axios.get(`barang-merk/kondisi/${this.tipeBarang.merk.id}`).then(response => {
                        this.tipeBarang.kondisi = response.data
                        this.toggleBusy();
                    })
                    .catch(error => {
                        console.log(error)
                        console.log(error.response.data.reason)
                        this.$helper.parseError(this, error)
                    })
                } 
                else this.toggleBusy()

                let msg = this.$helper.getFlash()
                this.$helper.toastSucc(this, msg)
            })

            Promise.all([getSingleTipeBarang]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })
        },
        
        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        toggleBusy() {
            if (this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

        editTipeBarang(){
            this.$router.push({path: `${this.$route.path}/edit`});
        }

    },
    
    created(){
        this.init()
    }
}
</script>
